import { Control, Controller, FieldErrors } from "react-hook-form";
import { MultiSelectAutocomplete } from "@/components/MultiSelectAutocomplete";
import { useTagsV2 } from "@/hooks/useTagsV2";
import { TAG_TYPE_NAME } from "@/types/tagsV2";
import { UserV2FormValues } from "./UserFormV2";

interface CanvasZipFormPartProps {
  control: Control<UserV2FormValues>;
  errors: FieldErrors<UserV2FormValues>;
  index: number;
  currentStateTags: number[];
  handleStatesChange: (selectedStates: number[]) => void;
}

export const CanvasZipFormPart = ({
  control,
  errors,
  index,
  currentStateTags,
  handleStatesChange,
}: CanvasZipFormPartProps) => {
  const { tagOptions: stateOptions, loadingTags } = useTagsV2(
    TAG_TYPE_NAME.STATE,
  );

  return (
    <Controller
      name={`roles.${index}.stateTags` as const}
      control={control}
      render={() => (
        <MultiSelectAutocomplete
          options={stateOptions}
          selected={currentStateTags}
          setSelected={handleStatesChange}
          label="Select States*"
          placeholder="Select From List"
          maxHeight={300}
          loading={loadingTags}
          error={!!errors.roles?.[index]?.stateTags}
          helperText={errors.roles?.[index]?.stateTags?.message}
        />
      )}
    />
  );
};
